import { Drama } from 'lucide-react';
import { useSession } from '@/contexts/SessionContext';
import { cn } from '@/lib/cn';

// Rehearsal (practice) mode switch — courtroom-ready sprint. Clearly labelled,
// one tap. ON keeps the IDENTICAL production path (same transcription, ask,
// classify pipelines) but writes to a separate practice session so mock
// hearings never pollute the real session history. Amber dashed treatment so
// the state is unmistakable in peripheral vision.
export function RehearsalToggle() {
  const { rehearsal, setRehearsal } = useSession();
  return (
    <button
      type="button"
      role="switch"
      aria-checked={rehearsal}
      onClick={() => setRehearsal(!rehearsal)}
      title={
        rehearsal
          ? 'Rehearsal mode is ON: this is a practice session. Tap to return to the real session.'
          : 'Tap to switch to a practice session (mock hearings stay out of real history).'
      }
      className={cn(
        'inline-flex h-9 shrink-0 items-center gap-1.5 rounded-md border px-2.5 text-[10px] font-medium uppercase tracking-[0.18em] transition-colors',
        rehearsal
          ? 'border-dashed border-amber-500/70 bg-amber-950/30 text-amber-400 hover:bg-amber-950/50'
          : 'border-stone-800 text-stone-500 hover:border-stone-700 hover:text-stone-300',
      )}
    >
      <Drama className="h-3.5 w-3.5" aria-hidden />
      {rehearsal ? 'Rehearsal on' : 'Rehearsal'}
    </button>
  );
}
